import { ENTITY_TYPE_ID_MAP } from 'UI/constants/entityTypes';

export const RESTRICTION_TYPES = {
  doNotContact: 'doNotContact',
  doNotEngage: 'doNotEngage'
};

const restrictionTypeValues = Object.values(RESTRICTION_TYPES);

export const isRestrictionType = type => restrictionTypeValues.includes(type);

export const RESTRICTION_STATUS_ID_BY_TYPE_AND_ENTITY = {
  [RESTRICTION_TYPES.doNotContact]: {
    [ENTITY_TYPE_ID_MAP.candidate]: 8,
    [ENTITY_TYPE_ID_MAP.hiringAuthority]: 4,
    [ENTITY_TYPE_ID_MAP.name]: 17
  },
  [RESTRICTION_TYPES.doNotEngage]: {
    [ENTITY_TYPE_ID_MAP.candidate]: 10,
    [ENTITY_TYPE_ID_MAP.hiringAuthority]: 6,
    [ENTITY_TYPE_ID_MAP.name]: 23
  }
};

export const getRestrictionStatusId = ({ entityTypeId, restrictionType }) =>
  RESTRICTION_STATUS_ID_BY_TYPE_AND_ENTITY[restrictionType]?.[entityTypeId] ?? null;

export const hasRestrictionStatus = ({ entityTypeId, profileStatusId, restrictionType }) => {
  const restrictionStatusId = getRestrictionStatusId({ entityTypeId, restrictionType });

  return !!profileStatusId && profileStatusId === restrictionStatusId;
};
